import { Code } from '@mui/icons-material'
import * as React from "react"
import { Button, Col, Container, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { Layout } from "../components/layout"
import { Head } from "../components/seo"


import IMG_POSMATCH from "../images/posmatch.png"
import IMG_TIMEHUNT from "../images/timehunt.png"
import img_excelout_eyecatch from "../images/excelout_eyecatch.svg";

export const ProductsPage: React.FC = () => {
  const { t } = useTranslation("translations", { keyPrefix: "PRODUCTS" })

  return (
    <Layout title="PRODUCTS" subtitle={t("SUBTITLE")}>
      <Head title="PRODUCTS" />
      <div className="my-4">
        <Container className="my-5">
          <h3 className="mb-4">
            <Code fontSize="medium" className="text-dark" />
            <span className="ms-2">{t("SOFTWARE_PRODUCTS")}</span>
          </h3>
          <Row>
            <Col md="4">
              <div className="mt-4 bg-light rounded">
                <img src={img_excelout_eyecatch} alt="excelout-eyecatch" />
              </div>
            </Col>
            <Col md="8" className="py-2 px-4 mb-5">
              <h3 className="fw-bold">Excelout</h3>
              <div className="ms-3">
                <p>{t("EXCELOUT.DESC_1")}</p>
                <p>{t("EXCELOUT.DESC_2")}</p>
                <h4>{t("EXCELOUT.FEATURES.TITLE")}</h4>
                <ul>
                  <li>{t("EXCELOUT.FEATURES.1")}</li>
                  <li>{t("EXCELOUT.FEATURES.2")}</li>
                  <li>{t("EXCELOUT.FEATURES.3")}</li>
                </ul>
              </div>
              <Row>
                <Col md={6} className="mb-3">
                  <a href="/#contact" style={{ textDecoration: "none" }}>
                    <Button variant="success" className="text-light rounded-0 d-flex align-items-center justify-content-center w-100">{t("EXCELOUT.BUTTON_DOCUMENT_REQUEST")}</Button>
                  </a>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
        <Container className="my-5">
          <Row>
            <Col md="4" className="px-5">

              <img src={IMG_POSMATCH} alt="excelout-eyecatch" className="img-fluid" />
            </Col>
            <Col md="8" className="py-2 px-4 mb-5">
              <h3 className="fw-bold">Posmatch</h3>
              <div className="ms-3">
                <p>{t("POSMATCH.DESC_1")}</p>
                <p>{t("POSMATCH.DESC_2")}</p>
              </div>
              <Row>
                <Col md={6} className="mb-3">
                  <Button variant="success" className="text-light rounded-0 d-flex align-items-center justify-content-center w-100" href="https://posmatch.herokuapp.com/">{t("POSMATCH.BUTTON_TRY")}</Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
        <Container className="my-5">
          <Row>
            <Col md="4" className="px-5">

              <img src={IMG_TIMEHUNT} alt="excelout-eyecatch" className="img-fluid" />
            </Col>
            <Col md="8" className="py-2 px-4 mb-5">
              <h3 className="fw-bold">timehunt</h3>
              <div className="ms-3">
                <p>{t("TIMEHUNT.DESC_1")}</p>
                <p>{t("TIMEHUNT.DESC_2")}</p>
              </div>
              <Row>
                <Col md={6} className="mb-3">
                  <Button variant="success" className="text-light rounded-0 d-flex align-items-center justify-content-center mb-3" href="https://www.npmjs.com/package/timehunt/" >{t("TIMEHUNT.BUTTON_DETAIL")}</Button>
                  <Button variant="success" className="text-light rounded-0 d-flex align-items-center justify-content-center mb-3" href="https://github.com/mk-system/timehunt/issues" >{t("TIMEHUNT.BUTTON_SUPPORT")}</Button>
                  <a href="/products/timehunt_privacy_policy" style={{ textDecoration: "none" }}>
                    <Button variant="info" className="text-light rounded-0 d-flex align-items-center justify-content-center w-100">{t("TIMEHUNT.BUTTON_PRIVACY_POLICY")}</Button>
                  </a>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  )
}